module.exports = __webpack_public_path__ + "static/media/avatar5.963ddd58.jpeg";